import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    value: 0
}

const indexStepSlice = createSlice({
    name: 'indexStep',
    initialState,
    reducers: {
        increment: (state) => {
            state.value += 1
        },
        decrement: (state) => {
            state.value -= 1
        }
    }
})

export const { increment, decrement } = indexStepSlice.actions
export default indexStepSlice.reducer